import { useState } from 'react';
import { Button, Drawer } from '@mui/material';

import AddCardDialog from './AddCardDialog';
import { CardBody } from '../style';

const AddCardButton = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => () => {
    setOpen(!open);
  };

  return (
    <CardBody>
      {/* TODO have a stripe here like a card mag strip */}
      <Button
        onClick={toggleDrawer()}
        style={{
          background: '#c0c0c0',
          width: '100%',
          height: '100%',
        }}
      >
        Add Card
      </Button>
      {/* TODO maybe move this drawer to AddCardDialog (also rename it to drawer) and move this state to CardList, thus deleting this file */}
      <Drawer anchor='bottom' open={open} onClose={toggleDrawer()}>
        <AddCardDialog handleClose={toggleDrawer()}></AddCardDialog>
      </Drawer>
    </CardBody>
  );
};

export default AddCardButton;
